import Vue from 'vue';

const RaceUtils = {

    calculateRaceStatistic(raceId) {
        return Vue.axios
            .get(`race/` + raceId +`/statistic/`)
            .then(response => {
                console.log('return calculate race statistic for :' + raceId);
                return response;
            });
    },
    PUT(race){
        return Vue.axios.put(`race`, race);
    },
    POST(race){
        return Vue.axios.post(`race`, race);
    },
    DELETE(id){
        return Vue.axios.delete(`race/` + id);
    },
    createOrUpdateRace(race) {
        let racePromis;
        if(race.id == undefined || race.id == null) {
            racePromis = this.PUT(race);
        } else {
            racePromis = this.POST(race);
        }
        return racePromis;
    }

}

export default RaceUtils;

